import EditVendorContactContainer from "./EditVendorContactContainer";
export default EditVendorContactContainer;
